




















import Vue from 'vue'
import firebase from 'firebase/app'

import { Component, Mixins } from 'vue-property-decorator'
import { State } from 'vuex-class'
import axios from 'axios'
import store, { Mutations } from '../../store'
import { IOnboardingPayload } from 'serverless-firestore'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LoginService from '@/services/login.service'
import VerifyPhone from '@/components/Onboarding/VerifyPhone.vue'

@Component({
  components: {
    VerifyPhone
  }
})
export default class VerifyAdminLogin extends Mixins(IconsMixin, AuthMixin) {
  @State('onboarding') public onboarding!: IOnboardingPayload

  private get adminPhoneNumber() {
    return this.onboarding.admin.phoneNumber
      ? this.onboarding.admin.phoneNumber.replace(/[()\- ]/g, '')
      : null
  }

  public async submit(credentials: firebase.auth.UserCredential) {
    await LoginService.loadUserAndRoute(this.$firebase, credentials, this.$router)
    store.commit(Mutations.UPDATE_ONBOARDING, { onboarding: null })
  }
}
